/** @jsx jsx */
import { jsx } from '@emotion/core'
import { isEmpty, VFlow } from 'bold-ui'
import { resolveName, SimNaoEnum } from 'components/form'
import { SimNaoSwitchButtonField } from 'components/form/field/SimNaoSwitchButtonField'
import { MChatPerguntaEnum } from 'graphql/types.generated'
import { useField } from 'react-final-form'
import { MetaPath } from 'util/metaPath'

import { ConsultaSeguimentoIndicatorResultado } from '../../components/ConsultaSeguimentoIndicatorResultado'
import { ConsultaSeguimentoIndicatorStart } from '../../components/ConsultaSeguimentoIndicatorStart'
import { ConsultaSeguimentoPerguntaHeader } from '../../components/ConsultaSeguimentoPerguntaHeader'
import { ConsultaSeguimentoPerguntaHeaderTitle } from '../../components/ConsultaSeguimentoPerguntaHeaderTitle'
import { PerguntaSimNaoRadioGroupBoxField } from '../../components/PerguntaSimNaoRadioGroupBoxField'
import { useConsultaSeguimentoSetResultado } from '../../hooks/useConsultaSeguimentoSetResultado'
import { PassouFalhouEnum } from '../../model-consultaSeguimento'
import { ConsultaSeguimentoPergunta13Model } from './model-consultaSeguimentoPergunta13'

interface ConsultaSeguimentoPergunta13FieldProps {
  name: MetaPath<ConsultaSeguimentoPergunta13Model>
}

export function ConsultaSeguimentoPergunta13Field(props: Readonly<ConsultaSeguimentoPergunta13FieldProps>) {
  const { name } = props

  const {
    input: { value },
  } = useField<ConsultaSeguimentoPergunta13Model>(resolveName(name), {
    subscription: { value: true },
  })

  useConsultaSeguimentoSetResultado<ConsultaSeguimentoPergunta13Model>({
    name,
    calculateResultado,
    conditionToCalculate,
  })

  return (
    <VFlow vSpacing={0}>
      <VFlow>
        <ConsultaSeguimentoPerguntaHeader
          pergunta={MChatPerguntaEnum.PERGUNTA_13}
          title={<ConsultaSeguimentoPerguntaHeaderTitle sufix=' anda?' />}
          status={value.status}
          field={<SimNaoSwitchButtonField name={name.PERGUNTA_13_HEADER} />}
        />
        {value?.PERGUNTA_13_HEADER === SimNaoEnum.SIM && (
          <VFlow vSpacing={0}>
            <ConsultaSeguimentoIndicatorStart />
            <PerguntaSimNaoRadioGroupBoxField
              name={name.PERGUNTA_13_ANDA_SEM_APOIO}
              label='Anda sem se segurar ou sem se apoiar em algo?'
              required
            />
          </VFlow>
        )}
      </VFlow>
      {value?.resultado && <ConsultaSeguimentoIndicatorResultado resultado={value.resultado} />}
    </VFlow>
  )
}

const calculateResultado = (values: ConsultaSeguimentoPergunta13Model) => {
  if (values?.PERGUNTA_13_HEADER === SimNaoEnum.NAO || values?.PERGUNTA_13_ANDA_SEM_APOIO === SimNaoEnum.NAO) {
    return PassouFalhouEnum.FALHOU
  } else if (values?.PERGUNTA_13_ANDA_SEM_APOIO === SimNaoEnum.SIM) {
    return PassouFalhouEnum.PASSOU
  }
}

const conditionToCalculate = (values: ConsultaSeguimentoPergunta13Model): boolean => {
  if (values?.PERGUNTA_13_HEADER === SimNaoEnum.NAO || !isEmpty(values?.PERGUNTA_13_ANDA_SEM_APOIO)) {
    return true
  }
  return false
}
